module.exports = {
  footerText: 'Copyright Learnira Technologies Pvt. Ltd.© 2020',
}
